function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import find from 'lodash/find';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import tail from 'lodash/tail';
import * as actions from 'modules/Organization/actions';
import { AppContext } from 'context';
import history from 'helpers/history';
import BackToMainView from 'components/BackToMainView';
import Steps from 'components/Steps';
import App from 'modules/App';
import Account from 'modules/Account';
import * as constants from '../../constants';
import messages from '../../messages';
import Country from './Country';
import Information from './Information';
import RequestSent from './RequestSent';
import Summary from './Summary';
var _React_PureComponent;
class CreateOrganization extends (_React_PureComponent = React.PureComponent) {
    componentWillUnmount() {
        this.props.onClearForm();
        this.onChangeView(this.viewsOrder[0]);
    }
    onChangeView(view, organizationProposal = null) {
        this.setState({
            view,
            organizationProposal
        });
    }
    onClose() {
        this.props.onClearForm();
        const backRouteName = this.props.isSetup ? 'organization-choose' : 'organization-memberships';
        const backUrl = this.context.getUrl(backRouteName);
        history.push(backUrl);
    }
    renderHeader() {
        if (this.props.isSetup) {
            return null;
        }
        return /*#__PURE__*/ _jsxs("header", {
            className: "pageHeader",
            children: [
                /*#__PURE__*/ _jsx(BackToMainView, {
                    routeName: "organization-memberships",
                    message: messages.headers.backToOrganizations
                }),
                /*#__PURE__*/ _jsx("h1", {
                    className: "text--h1",
                    children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.headers.createOrganization))
                })
            ]
        });
    }
    renderContent() {
        const View = this.views[this.state.view];
        const template = this.viewsOrder.map((id)=>({
                id,
                labelMessage: messages.steps.create[id]
            }));
        const activeStepIdx = this.viewsOrder.findIndex((v)=>v === this.state.view);
        return /*#__PURE__*/ _jsx(View, {
            StepsElement: /*#__PURE__*/ _jsx(Steps, {
                template: template,
                activeStepIdx: activeStepIdx
            }),
            activeStepIdx: activeStepIdx,
            organizationProposal: this.state.organizationProposal,
            onChangeView: (view, organizationProposal)=>this.onChangeView(view, organizationProposal),
            onClose: ()=>this.onClose()
        });
    }
    render() {
        return /*#__PURE__*/ _jsxs(_Fragment, {
            children: [
                this.renderHeader(),
                this.renderContent()
            ]
        });
    }
    constructor(props){
        var _props_formValues_values, _props_formValues;
        super(props);
        this.views = {
            Country,
            Information,
            RequestSent,
            Summary
        };
        this.viewsOrder = [
            'Country',
            'Information',
            'Summary'
        ];
        let countryCode = (_props_formValues = props.formValues) === null || _props_formValues === void 0 ? void 0 : (_props_formValues_values = _props_formValues.values) === null || _props_formValues_values === void 0 ? void 0 : _props_formValues_values.countryCode;
        if (!countryCode) {
            const countryCodes = props.identities.filter((identity)=>Account.constants.BUSINESS_SCOPES.includes(identity.scope)).map((identity)=>identity.countryCode);
            if (countryCodes.length === 1) {
                countryCode = countryCodes[0];
            }
        }
        if (countryCode) {
            this.viewsOrder = tail(this.viewsOrder);
            const country = find(props.countries, {
                alpha2Code: countryCode
            });
            const { defaultLanguageCode } = country;
            props.onSetFormValues({
                countryCode,
                languageCode: defaultLanguageCode
            });
            props.onFetchOrganizationTemplate(countryCode);
        }
        this.state = {
            view: this.viewsOrder[0],
            organizationProposal: null
        };
    }
}
_define_property(CreateOrganization, "contextType", AppContext);
_define_property(CreateOrganization, "propTypes", {
    // Explicit props
    countryCode: PropTypes.string,
    isSetup: PropTypes.bool,
    isInProgress: PropTypes.bool,
    // Implicit props
    identities: PropTypes.array.isRequired,
    countries: PropTypes.arrayOf(App.shapes.country),
    formValues: PropTypes.object,
    // Implicit actions
    onFetchOrganizationTemplate: PropTypes.func,
    onClearForm: PropTypes.func,
    onSetFormValues: PropTypes.func
});
const mapStateToProps = (state)=>({
        identities: Account.selectors.identities(state),
        countries: App.selectors.countries(state),
        formValues: App.selectors.formSelector(constants.CREATE_FORM)(state)
    });
const mapDispatchToProps = (dispatch)=>({
        onFetchOrganizationTemplate: (countryCode)=>dispatch(actions.fetchOrganizationTemplate(countryCode)),
        onClearForm: ()=>dispatch(App.actions.clearForm(constants.CREATE_FORM)),
        onSetFormValues: (values)=>dispatch(App.actions.setFormValues(constants.CREATE_FORM, values))
    });
const ConnectedCreateOrganization = connect(mapStateToProps, mapDispatchToProps)(CreateOrganization);
export default ConnectedCreateOrganization;
